export default __webpack_public_path__ + "static/8-tips-for-saving-money-for-your-next-holiday-798f7ab12d3bafb1cc437af4b22bfb9b.jpg";